/**
 * JSONP client.
 */

module.exports = function (_) {

    var Promise = require('../promise')(_);

    return function (request) {
        return new Promise(function (resolve) {

            var callback = '_jsonp' + Math.random().toString(36).substr(2), response = {request: request, data: null}, handler, script;

            request.params[request.jsonp] = callback;
            request.cancel = function () {
                handler({type: 'cancel'});
            };

            script = document.createElement('script');
            script.src = _.url(request);
            script.type = 'text/javascript';
            script.async = true;

            window[callback] = function (data) {
                response.data = data;
            };

            handler = function (event) {

                if (event.type === 'load' && response.data !== null) {
                    response.status = 200;
                } else if (event.type === 'error') {
                    response.status = 404;
                } else {
                    response.status = 0;
                }

                resolve(response);

                delete window[callback];
                document.body.removeChild(script);
            };

            script.onload = handler;
            script.onerror = handler;

            document.body.appendChild(script);
        });
    };

};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-resource/src/client/jsonp.js
// module id = 159
// module chunks = 1